
<script>
import { saveAs } from 'file-saver'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import { required, email, numeric, helpers } from 'vuelidate/lib/validators'
import { driversLicense, USDLRegex } from 'src/utils/validators'
import DocumentUpload from '../Document/DocumentUpload'
import StudentDetailsTab from './StudentDetailsTab'
import StudentClassesTab from './StudentClassesTab'
import StudentDocumentsTab from './StudentDocumentsTab'
import StudentNotesTab from './StudentNotesTab'
import { toArrayBuffer } from 'src/utils'

export default {
  name: 'StudentDetails',
  components: {
    DocumentUpload,
    StudentDetailsTab,
    StudentClassesTab,
    StudentDocumentsTab,
    StudentNotesTab
  },
  data () {
    return {
      title: this.$route.meta.title,
      module: this.$route.meta.module,
      sparse: true,
      separator: true,
      hideEntity: true,
      removeDialogOptions: {
        title: 'Remove Student?',
        message: 'Are you sure you want to remove this student?',
        ok: {
          label: 'Remove',
          color: 'negative'
        },
        cancel: {
          label: 'Cancel'
        }
      }
    }
  },
  validations () {
    return {
      studentForm: {
        STUDENT_FIRST_NAME: { required },
        STUDENT_LAST_NAME: { required },
        STUDENT_EMAIL: { email },
        STUDENT_PHONE: { required, numeric }
      },
      driversLicenseForm: {
        DRIVERS_LICENSE: { 
          required, 
          driversLicenseValidation: driversLicense(this.stateAbbrev)
        },
        LK_STATE_ID: { required }
      }
    }
  },
  computed: {
    validation () { 
      return this.$v 
    },
    ...mapState({
      mode: state => state.shared.detailsModal.mode
    }),
    ...mapState('students', {
      role: (state) => state.role,
      studentForm: state => state.studentForm,
      addressForm: state => state.addressForm,
      driversLicenseForm: state => state.driversLicenseForm,
      classStudentList: state => state.classStudentList,
      list: state => state.list
    }),
    ...mapGetters('students', [
      'stateAbbrev'
    ])
  },
  methods: {
    driversLicenseValidation (value) {
      if(!value) return true
      const stateRegex = new RegExp(USDLRegex[this.stateAbbrev].rule)
      const valid = stateRegex.test(value)
      return valid
    },
    ...mapActions('students', [
      'add',
      'addNew',
      'select',
      'create',
      'update',
      'remove'
    ]),
    ...mapMutations('students', [
      'updateRole'
    ]),
    ...mapMutations([
      'closeDetails'
    ]),
    successHandler (response) {
      this.$v.$reset()
    },
    generateCertificate () {
      this.$store.dispatch('certificates/generateCertificate')
      .then(response => {
        saveAs(
          new Blob([toArrayBuffer(response.data.content.data)],
          {type: 'application/octet-stream'}),
          'cert.pdf'
        )
      })
    },
    onSelect (student) {
      this.select(student).then(this.$v.$touch)
    },
    onAddAnother () {
      this.addAnother().then(this.successHandler)
    },
    onAddNew () {
      this.addNew().then(this.successHandler)
    },
    onAdd () {
      this.add().then(this.successHandler)
    },
    onUpdate () {
      this.update().then(this.successHandler)
    },
    onRemove () {
      this.$q.dialog(this.removeDialogOptions)
      .then(this.remove)
      .catch(err => err)
    },
    openUploadModal () {
      this.$store.dispatch('documents/openUploadModal', 
      { LK_ENTITY_ID: 2, ENTITY_ITEM_ID: this.studentForm.STUDENT_ID }, 
      { root: true })
    }
  }
}

</script>

<template>

  <div class="details-inner">        
    <div class="sl-row sl-abs">
      <!-- <div>
        <q-list highlight :separator="separator" :sparse="sparse" v-if="mode === 'add'">
          <q-list-header >Class Students</q-list-header>
          <q-item-separator> </q-item-separator>
          <q-item v-for="(student, index) in list" :key="index" @click.native="onSelect(student)">
            <q-item-main :label="student.STUDENT_FIRST_NAME + ' ' + student.STUDENT_LAST_NAME"/>
          </q-item>
        </q-list>
        <q-list highlight :separator="separator" :sparse="sparse" v-if="mode === 'edit'">
          <q-item @click.native="onAddNew()">
            <q-item-side left>
              <q-item-tile icon="add" color="green" />
            </q-item-side>
            <q-item-main label="Add Student"/>
          </q-item>
          <q-list highlight :separator="separator" :sparse="sparse">
            <q-list-header>
              <div class="sl-row"> <div class="sl-col-10"> Students </div></div>
            </q-list-header>
            <q-item v-for="(student, index) in list" :key="index" @click.native="onSelect(student)" >
              <q-item-main :label="student.STUDENT_FIRST_NAME + ' ' + student.STUDENT_LAST_NAME"/>
            </q-item>
            <q-item v-if="list.length === 0">
              <div>No Students Available.</div>
            </q-item>
          </q-list>
        </q-list>
      </div> -->
      <div class="sl-col-12 no-padding">
        <q-card class="">
          <q-tabs
            class="col-9"
            no-pane-border
            align="center"
          >
            <!-- Tabs - notice slot="title" -->
            <q-tab default slot="title" name="details" label="Details"
              :alert="validation.studentForm.$invalid 
              || validation.driversLicenseForm.$invalid" ></q-tab>
            <q-tab slot="title" name="classes" label="Classes"></q-tab>
            <q-tab slot="title" name="documents" label="Documents"></q-tab>
            <!-- <q-tab slot="title" name="notes" label="Notes"></q-tab> -->

            <!-- Targets -->
            <q-tab-pane name="details" class="fit" >
              <student-details-tab 
                :validation="validation"
                :studentForm="studentForm"
              />
            </q-tab-pane>
            <q-tab-pane name="classes" class="fit" >
              <student-classes-tab :studentId="studentForm.STUDENT_ID"/>
            </q-tab-pane>
            <q-tab-pane name="documents" class="no-padding">
              <student-documents-tab :studentId="studentForm.STUDENT_ID"/>
            </q-tab-pane>
            <q-tab-pane name="notes" class="fit">
              <student-notes-tab />
            </q-tab-pane>
          </q-tabs>
        </q-card>
        <document-upload 
          :hideEntity="hideEntity"
        />
      </div>
      <q-toolbar>
        <q-btn
          v-if="mode === 'edit'"
          color="red"
          label="Remove"
          @click="onRemove()"
        />
        <q-toolbar-title>
        </q-toolbar-title>
        <div class="q-px-sm">
          <q-btn
            v-if="mode === 'edit'"
            class="q-px-md"
            label="Upload"
            color="green"
            @click="openUploadModal()"
          />
        </div>
        <div class="q-px-sm">
          <q-btn
            v-if="mode === 'edit'"
            class="q-px-md"
            label="Generate Class Certificate"
            color="green"
            @click="generateCertificate()"
          />
        </div>
        <div class="q-px-sm">
          <q-btn
            v-if="mode === 'edit'"
            class="q-px-md"
            color="green"
            label="Save"
            :disable="$v.$invalid"
            @click="onUpdate()"
          />
        </div>
        <div class="q-px-sm">
          <q-btn
            v-if="mode === 'add'"
            class="q-px-md"
            color="green"
            label="Add"
            :disable="$v.studentForm.$invalid"
            @click="onAdd()"
          />
        </div>
        <q-btn outline color="faded" @click.native="closeDetails" label="Cancel" />
      </q-toolbar>
    </div>
  </div>
</template>

<style scoped lang="stylus">
.q-tabs-panes {
  display: flex;
  overflow: scroll;
  max-width: 1400px;
  margin: 0 auto;
}
.sl-row.sl-abs{
  height calc(100% - 110px)
}

</style>
